import React, {Fragment, useContext, useEffect, useState} from 'react';
import {
    Button, Snackbar,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import CoberturasForm from './Forms/CoberturasForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import {useAuth0} from "@auth0/auth0-react";

import axios from 'axios';
import CotizarContext from "../../../../../context/CotizarContext";
import Alert from "@material-ui/lab/Alert";
import white_microseg_icon from "../../../../../assets/images/white_microseg_icon.png";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";
import moment from "moment";

const steps = ['Coberturas'];
const {formId, formField} = formModel;

export default function CheckoutPage(props) {
    const cotizacionRetomada = props.cotizacionRetomada; //Indicates if it's a new quote or it isn't
    const nuevoFormInitialValues = props.cotizacionValues;
    const action = props.action;
    const handlerEndCotizacion = props.handlerEndCotizacion;
    const setIsCotizarDone = props.setIsCotizarDone;
    const setIsCotizando = props.setIsCotizando;
    const [isCotizarDone2, setIsCotizarDone2] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(action === 'emitir' ? steps.length : 0);
    const currentValidationSchema = validationSchema[activeStep];
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const {getIdTokenClaims} = useAuth0();
    const {afinidadesPic, coberturasInfo} = useContext(CotizarContext)
    const {handleModified} = useContext(IndicatorsContext)
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    let nuevoInitialValues;
    if (cotizacionRetomada) {
        //Si la fecha de hoy es despues de la fecha cotización
        if (moment(moment().format('YYYY-MM-DD')).isAfter(nuevoFormInitialValues['FechaCotizacion']))
            nuevoFormInitialValues['FechaCotizacion'] = moment().format('YYYY-MM-DD');

        nuevoInitialValues = {
            'afinidad': nuevoFormInitialValues.idAfinidad.toString(),
            'tamanioVivienda': "Chica",
            'tipoVivienda': "1022",
            "codigosLocalidad": nuevoFormInitialValues.CodigosLocalidad,
            "descuentoEspecial": nuevoFormInitialValues.DescuentoEspecial,
            "coberturasAdicionales": nuevoFormInitialValues.coberturas,
            "fechaCotizacion": nuevoFormInitialValues['FechaCotizacion'],

            //This is only gonna be sended when it's a "recotizacion"
            "id": nuevoFormInitialValues.id,
            "is_saved": true
        }

        if (nuevoFormInitialValues.Clientes !== null) {
            nuevoInitialValues = {
                ...nuevoInitialValues,
                "nombre": nuevoFormInitialValues.Clientes.Nombre,
                "apellido": nuevoFormInitialValues.Clientes.Apellido,
                "email": nuevoFormInitialValues.Clientes.Email,
                "dni": nuevoFormInitialValues.Clientes.DNI,
                "codigoArea": nuevoFormInitialValues.Clientes.CodArea,
                "telefono": nuevoFormInitialValues.Clientes.Telefono,
                "idCliente": nuevoFormInitialValues.idCliente
            }
        }
    }

    async function _submitForm(values, actions) {
        setIsCotizarDone2(false)
        setIsCotizando(true)

        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;
        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar/combinado';
        let initalCoberturasValues = values.coberturasAdicionales
        values.origen = 'affinity';
        values.microseguro = true;
        afinidadesPic.map(af => {
            if (af.id === values.afinidad) {
                values.img_afinidad = af.pic;
            }
        })
        setIsCotizarDone(false)
        if (action === 'emitir') {
            values.coberturasAdicionales.map((cob) => {
                cob.selectedCobertura = true;
            })
        }

        let valuesSend = values;
        let coberturasFinal = [];

        for (let cobertura of valuesSend.coberturasAdicionales) {
            if (cobertura.selectedCobertura) {
                valuesSend.producto = cobertura.numeroCobertura
                coberturasFinal.push(
                    {
                        sumaAsegurada: cobertura.sumaAsegurada,
                        numeroCobertura: cobertura.numeroCobertura,
                    }
                )
            }
        }

        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                sumaMinima: item.SumaMinima,
            });

        coberturasFinal.push(
            {
                sumaAsegurada: dict['1'].sumaMinima,
                numeroCobertura: '1',
            },
            {
                sumaAsegurada: dict['2'].sumaMinima,
                numeroCobertura: '2',
            },
        )

        valuesSend.coberturas = coberturasFinal
        if (cotizacionResponse !== null) {
            valuesSend.id = cotizacionResponse.idCotizacion;
            valuesSend.is_saved = true
        }

        axios.post(url, {...valuesSend, ...{saveToDatabase: true}}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${id_token}`,
            }
        }).then(res => {
            values.coberturasAdicionales = initalCoberturasValues
            valuesSend.coberturas = coberturasFinal
            setFinalValues(valuesSend);

            res.data.idCotizacion = res.data.cotizacionId
            setCotizacionResponse(res.data);
            setIsCotizarDone2(true)
            if (action !== 'emitir')
                actions.setSubmitting(false);
            if (!valuesSend.is_saved)
                handleModified()
        }).catch(err => {
            setIsCotizando(false);
            if (action !== 'emitir')
                actions.setSubmitting(false);
            handleOpenAlert("Ha habido un error: " + err)
        });
    }

    function _handleSubmit(values, actions) {
        actions.setTouched({});
        actions.setSubmitting(true);
        setCotizacionResponse(null)
        _submitForm(values, actions);
        setActiveStep(activeStep + 1)
    }

    useEffect(() => {
        if (action === 'emitir') {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            } else {
                setFinalValues(nuevoInitialValues)
                _submitForm(nuevoInitialValues);
            }
        } else {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            }
        }
    }, [isCotizarDone2]);

    return (
        <React.Fragment>

            {action !== 'emitir'
            &&
            <div className={classes.formBox}>
                <div className={classes.iconCircle}>
                    <img src={white_microseg_icon} style={{width: "36px", height: "auto"}}/>
                </div>
                <Fragment>
                    <Formik
                        initialValues={cotizacionRetomada ? nuevoInitialValues : formInitialValues}
                        validationSchema={currentValidationSchema}
                        validateOnBlur={false}
                        onSubmit={_handleSubmit}
                    >
                        {({isSubmitting}) => (
                            <Form id={formId}>
                                <CoberturasForm formField={formField} cotizacionRetomada={cotizacionRetomada}/>
                                <div className={classes.buttons}>
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className={classes.buttonContained}
                                    >
                                        Cotizar
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Fragment>

                <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                    <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                           classes={{filledWarning: classes.alert}}
                    >
                        {alertMessage}
                    </Alert>
                </Snackbar>
            </div>
            }
        </React.Fragment>
    );
}
